import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'; 



function Cta() {
    
    return (
        
        <div className="cta-wrapper" id="cislo">
            <h2 className="cta-title">Dokážeme zhmotnit i Vaše představy</h2>
            <Link to="/"><button className="cta-btn">Kontaktujte nás</button></Link>
        </div>    
    );
  }

export default Cta

// funkci napíšu v contextu, tady ju spustím a v
// contextu bude zadefinovaná poloha contact v home.js


// WEBPACK FOOTER //
// ./src/components/Cta.js